<template>
  <b-overlay :show="sendingData" rounded="sm">
    <template #overlay>
      <div class="text-center">
        <p id="cancel-label">Please wait...</p>
        <b-spinner label="Spinning"></b-spinner>
      </div>
    </template>
    <component @on-change-component="onChangeComponent"
               @on-check-number-students="checkNumberOfStudents"
               v-bind:is="currentComponent" @change-tab="(tabIndex) => $emit('change-tab', tabIndex)"
               v-bind="{...$props,...currentComponentParams}"
    ></component>
  </b-overlay>
</template>

<script>
import ClassroomDetailTabItemStudents from "./ClassroomDetailTabItemStudents"
import ClassroomDetailTabStudentDetail from "./ClassroomDetailTabStudentDetail"
import { ClassroomService } from '@/core/Services'

export default {
  name: "ClassroomDetailTabMyStudents",
  components: {
    ClassroomDetailTabItemStudents,
    ClassroomDetailTabStudentDetail
  },
  data() {
    return {
      currentComponent: null,
      currentComponentParams: {},
      sendingData: false
    }
  },
  props: {
    classroom: Object,
  },
  mounted() {
    this.onChangeComponent({component: 'ClassroomDetailTabItemStudents'})
  },
  methods: {
    onChangeComponent(data) {
      this.currentComponent = data.component;
      this.currentComponentParams = data.params || {}
    },
    checkNumberOfStudents() {
      ClassroomService.checkNumberOfStudents(this.classroom.id).then((response) => {
        const data = response.data

        if (data.students_number !== data.partner_student_number) {
          this.$bvModal.msgBoxOk(
            `The number of groups in this classroom is now [${data.students_number}] but the partner classroom has [${data.partner_student_number}] groups.`,
            {
              size: 'sm',
              dialogClass: 'modal-message-box',
              noCloseOnBackdrop: true,
              centered: true
            }
          )
        }
      })
    },
  }
}
</script>

<style lang="stylus" scoped>


</style>
